import { Checkbox } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const PPMFilter = () => {
    const { t } = useTranslation();

    const { isPPMFilterActive, setIsPPMFilterActive } = usePlacementStore(
        useShallow((state) => ({
            isPPMFilterActive: state.isPPMFilterActive,
            setIsPPMFilterActive: state.setIsPPMFilterActive
        }))
    );

    return (
        <div className="flex flex-col px-3 mt-3">
            <span className="text-xs font-medium text-text-light uppercase tracking-wide">
                {t('labelProductStrategy')}
            </span>
            <Checkbox
                checked={isPPMFilterActive}
                className="p-3 pl-0.5"
                label={t('labelPPMFilter')}
                onChange={(e) => setIsPPMFilterActive(e.currentTarget.checked)}
            />
        </div>
    );
};
